export const environment = {
  production: true,
  staging: true,
  DATE_FORMAT: 'dd.MM.yyyy',
  DATE_TIME_FORMAT: 'dd.MM.yyyy HH:mm:ss',
  AG_DATE_FORMAT: 'DD.MM.yyyy',
  AG_DATE_TIME_FORMAT: 'MM/DD/yyyy HH:mm:ss',
  apiUrl: 'https://staging.api.ltytech.ch/',
  tokenValidityTimeMinutes: 60,

  VERSION: '1.0.14',
};
